(() => {
    const SECTION_TYPE = 'trade-application-form';
    const TRADE_FORM_JS_VERSION = '3';
    const ALLOWED_FILE_EXT = ['.pdf', '.jpg', '.jpeg', '.png'];
    const ALLOWED_FILE_MESSAGE = 'Only PDF, JPG, JPEG, and PNG files are allowed';
    const MAX_FILE_BYTES = 4 * 1024 * 1024;
    const MAX_FILE_SIZE_MESSAGE = 'Each file must be under 4MB. Please compress the PDF or choose a smaller image.';
    const SUBMIT_TIMEOUT_MS = 180000;
    const EMAIL_RE = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i;
  
    const COUNTRIES = [
      { iso: 'US', name: 'United States', dial: '+1', flag: '🇺🇸' },
      { iso: 'CA', name: 'Canada', dial: '+1', flag: '🇨🇦' },
      { iso: 'GB', name: 'United Kingdom', dial: '+44', flag: '🇬🇧' },
      { iso: 'AU', name: 'Australia', dial: '+61', flag: '🇦🇺' },
      { iso: 'NZ', name: 'New Zealand', dial: '+64', flag: '🇳🇿' },
      { iso: 'IE', name: 'Ireland', dial: '+353', flag: '🇮🇪' },
      { iso: 'FR', name: 'France', dial: '+33', flag: '🇫🇷' },
      { iso: 'DE', name: 'Germany', dial: '+49', flag: '🇩🇪' },
      { iso: 'IT', name: 'Italy', dial: '+39', flag: '🇮🇹' },
      { iso: 'ES', name: 'Spain', dial: '+34', flag: '🇪🇸' },
      { iso: 'PT', name: 'Portugal', dial: '+351', flag: '🇵🇹' },
      { iso: 'NL', name: 'Netherlands', dial: '+31', flag: '🇳🇱' },
      { iso: 'BE', name: 'Belgium', dial: '+32', flag: '🇧🇪' },
      { iso: 'CH', name: 'Switzerland', dial: '+41', flag: '🇨🇭' },
      { iso: 'AT', name: 'Austria', dial: '+43', flag: '🇦🇹' },
      { iso: 'SE', name: 'Sweden', dial: '+46', flag: '🇸🇪' },
      { iso: 'NO', name: 'Norway', dial: '+47', flag: '🇳🇴' },
      { iso: 'DK', name: 'Denmark', dial: '+45', flag: '🇩🇰' },
      { iso: 'FI', name: 'Finland', dial: '+358', flag: '🇫🇮' },
      { iso: 'IN', name: 'India', dial: '+91', flag: '🇮🇳' },
      { iso: 'JP', name: 'Japan', dial: '+81', flag: '🇯🇵' },
      { iso: 'KR', name: 'South Korea', dial: '+82', flag: '🇰🇷' },
      { iso: 'CN', name: 'China', dial: '+86', flag: '🇨🇳' },
      { iso: 'HK', name: 'Hong Kong', dial: '+852', flag: '🇭🇰' },
      { iso: 'SG', name: 'Singapore', dial: '+65', flag: '🇸🇬' },
      { iso: 'AE', name: 'United Arab Emirates', dial: '+971', flag: '🇦🇪' },
      { iso: 'SA', name: 'Saudi Arabia', dial: '+966', flag: '🇸🇦' },
      { iso: 'IL', name: 'Israel', dial: '+972', flag: '🇮🇱' },
      { iso: 'ZA', name: 'South Africa', dial: '+27', flag: '🇿🇦' },
      { iso: 'BR', name: 'Brazil', dial: '+55', flag: '🇧🇷' },
      { iso: 'MX', name: 'Mexico', dial: '+52', flag: '🇲🇽' },
      { iso: 'AR', name: 'Argentina', dial: '+54', flag: '🇦🇷' },
    ];
  
    function initSection(section) {
      const form = section.querySelector('[data-trade-form]');
      if (!form || form.dataset.tradeInit === 'true') return;
      form.dataset.tradeInit = 'true';
      form.dataset.tradeJsVersion = TRADE_FORM_JS_VERSION;
      form.dataset.formStartedAt = String(Date.now());
      console.info('[trade-application] js', TRADE_FORM_JS_VERSION);
  
      const successEl = section.querySelector('[data-trade-success]');
      const errorEl = form.querySelector('[data-trade-error]');
      const submitBtn = form.querySelector('.trade-app__submit');
  
      form.querySelectorAll('[data-trade-file-field]').forEach(setupFileField);
      form.querySelectorAll('[data-trade-phone-field]').forEach(setupPhoneField);
      setupClearInvalidOnEdit(form);
  
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        clearError(errorEl);
        clearInvalid(form);
  
        if (!validateForm(form)) return;
  
        const payload = buildPayload(form);
        const endpoint = form.dataset.apiEndpoint || '/api/trade-application';
        const endpointError = getEndpointError(endpoint);
  
        if (endpointError) {
          showError(errorEl, endpointError);
          return;
        }
        
        const sizeError = getFileSizeError(payload.files);
        if (sizeError) {
          showError(errorEl, sizeError);
          return;
        }
  
        try {
          if (submitBtn) submitBtn.disabled = true;
  
          form.dispatchEvent(
            new CustomEvent('trade-application:submit', {
              bubbles: true,
              detail: payload,
            })
          );
  
          // const formData = buildFormData(form, payload);
          const hasFiles = Object.values(payload.files || {}).some((list) => list?.length);
          const controller = new AbortController();
          const timeoutMs = hasFiles ? SUBMIT_TIMEOUT_MS : 60000;
          const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
  
          let response;
          try {
            const fileGids = hasFiles
              ? await uploadFilesOneByOne(endpoint, payload.files, controller.signal)
              : {};
            const formData = buildFormData(form, payload, fileGids);
            response = await fetch(endpoint, {
              method: 'POST',
              body: formData,
              headers: { Accept: 'application/json' },
              signal: controller.signal,
            });
          } catch (fetchError) {
            if (fetchError?.name === 'AbortError') {
              console.error('[trade-application] submit timeout', {
                endpoint,
                pageOrigin: window.location.origin,
                timeoutMs,
                hasFiles,
              });
              throw new Error(
                hasFiles
                  ? 'Upload timed out. Please try again with a smaller PDF or image.'
                  : 'The request timed out. Please try again.'
              );
            }
            if (fetchError?.message && !/failed to fetch/i.test(fetchError.message)) {
              throw fetchError;
            }
            console.error('[trade-application] network error', {
              endpoint,
              pageOrigin: window.location.origin,
              pageHref: window.location.href,
              errorName: fetchError?.name,
              errorMessage: fetchError?.message,
              hint:
                'Browser could not complete the request (often CORS or a file over Vercel’s 4.5MB limit). ' +
                'Local preview: http://127.0.0.1:9292. Live origin must be allowed by API CORS.',
            });
            throw new Error('We could not submit your application. Please check your connection and try again.');
          } finally {
            clearTimeout(timeoutId);
          }
  
          let data = {};
          try {
            data = await response.json();
          } catch (_) {
            data = {};
          }
  
          if (!response.ok || data.success === false) {
            if (data.errors && typeof data.errors === 'object') {
              applyServerFieldErrors(form, data.errors);
              const first = Object.values(data.errors)[0];
              throw new Error(first || data.message || 'Please check the form and try again.');
            }
            throw new Error(data.message || 'Something went wrong. Please try again.');
          }
  
          showSuccess(form, successEl, form.dataset.successTitle, form.dataset.successMessage);
        } catch (error) {
          console.error('[trade-application] submit failed', {
            userMessage: error?.message,
            error,
          });
          const hasFieldErrors = form.querySelector('[data-trade-field-error]:not([hidden])');
          if (!hasFieldErrors) {
            showError(errorEl, error?.message || 'Something went wrong. Please try again.');
          }
        } finally {
          if (submitBtn) submitBtn.disabled = false;
        }
      });
    }
  
    function collectRequiredKeys(form) {
      const required = new Set();
  
      form.querySelectorAll('[data-field-key][required], [data-field-key][aria-required="true"]').forEach((el) => {
        if (el.dataset.fieldKey) required.add(el.dataset.fieldKey);
      });
  
      form.querySelectorAll('fieldset[data-required="true"]').forEach((fieldset) => {
        const key = fieldset.querySelector('[data-field-key]')?.dataset.fieldKey;
        if (key) required.add(key);
      });
  
      form.querySelectorAll('input[data-field-type="file"][required]').forEach((el) => {
        if (el.dataset.fieldKey) required.add(el.dataset.fieldKey);
      });
  
      // Always require core identity fields for the API
      required.add('email');
      required.add('phone');
      required.add('first_name');
      required.add('last_name');
  
      return [...required];
    }
  
    function buildFormData(form, payload, fileGids) {
      const fd = new FormData();
  
      fd.append('email', payload.email || '');
      fd.append('phone', payload.phone || '');
      fd.append('phoneCountry', payload.phoneCountry || '');
      fd.append('phoneDialCode', payload.phoneDialCode || '');
      fd.append('firstName', payload.firstName || '');
      fd.append('lastName', payload.lastName || '');
      fd.append('tags', (payload.tags || []).join(','));
      fd.append('sendCustomerEmail', String(Boolean(payload.sendCustomerEmail)));
      fd.append('adminEmail', payload.adminEmail || '');
      fd.append('honeypot', form.querySelector('[name="honeypot"]')?.value || '');
      fd.append(
        'formStartedAt',
        form.dataset.formStartedAt || String(Date.now())
      );
      fd.append('required', JSON.stringify(collectRequiredKeys(form)));
  
      Object.entries(payload.fields || {}).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          fd.append(`fields[${key}]`, JSON.stringify(value));
        } else if (value != null) {
          fd.append(`fields[${key}]`, String(value));
        }
      });
      
      if (fileGids && Object.keys(fileGids).length) {
        Object.entries(fileGids).forEach(([key, ids]) => {
          fd.append(`fileGids[${key}]`, JSON.stringify(ids || []));
        });
      } else {
      Object.entries(payload.files || {}).forEach(([key, list]) => {
        (list || []).forEach((file) => {
          fd.append(`files[${key}]`, file, file.name);
        });
      });
    }
  
      return fd;
    }

    function joinEndpoint(endpoint, suffix) {
      return String(endpoint || '').replace(/\/?$/, '') + '/' + suffix;
    }

    function getFileSizeError(filesByField) {
      for (const list of Object.values(filesByField || {})) {
        for (const file of list || []) {
          if (file.size > MAX_FILE_BYTES) {
            return `"${file.name}" is too large. ${MAX_FILE_SIZE_MESSAGE}`;
          }
        }
      }
      return null;
    }

    async function uploadFilesOneByOne(endpoint, filesByField, signal) {
      const gids = {};
      const fileUrl = joinEndpoint(endpoint, 'file');

      for (const [key, list] of Object.entries(filesByField || {})) {
        gids[key] = [];
        for (const file of list || []) {
          const fd = new FormData();
          fd.append(`files[${key}]`, file, file.name);
          const res = await fetch(fileUrl, {
            method: 'POST',
            body: fd,
            headers: { Accept: 'application/json' },
            signal,
          });
          let data = {};
          try {
            data = await res.json();
          } catch (_) {
            data = {};
          }
          if (!res.ok || data.success === false || !data.fileId) {
            const message =
              data.message ||
              data.errors?.files ||
              MAX_FILE_SIZE_MESSAGE;
            throw new Error(message);
          }
          gids[key].push(data.fileId);
        }
      }

      return gids;
    }
  
    function setupPhoneField(field) {
      const btn = field.querySelector('[data-trade-phone-country-btn]');
      const list = field.querySelector('[data-trade-phone-country-list]');
      const flagEl = field.querySelector('[data-trade-phone-flag]');
      const dialEl = field.querySelector('[data-trade-phone-dial]');
      const nationalInput = field.querySelector('[data-trade-phone-national]');
      const fullInput = field.querySelector('[data-trade-phone-full]');
      const isoInput = field.querySelector('[data-trade-phone-iso]');
      const dialValueInput = field.querySelector('[data-trade-phone-dial-value]');
      const phoneBox = field.querySelector('.trade-app__phone-box');
  
      if (!btn || !list || !nationalInput || !fullInput) return;
  
      let selected = COUNTRIES[0];
  
      const syncFullPhone = () => {
        const national = (nationalInput.value || '').replace(/[^\d\s\-().]/g, '').trim();
        const full = national ? `${selected.dial} ${national}` : selected.dial;
        fullInput.value = full;
        if (dialValueInput) dialValueInput.value = selected.dial;
        if (isoInput) isoInput.value = selected.iso;
      };
  
      const setCountry = (country, { focusNational = false } = {}) => {
        selected = country;
        if (flagEl) flagEl.textContent = country.flag;
        if (dialEl) dialEl.textContent = country.dial;
        btn.setAttribute('aria-label', `Country code, ${country.name} ${country.dial}`);
        syncFullPhone();
        renderList();
        if (focusNational) nationalInput.focus();
      };
  
      const closeList = () => {
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
      };
  
      const openList = () => {
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        const active = list.querySelector('[aria-selected="true"]');
        active?.focus?.();
      };
  
      const renderList = () => {
        list.innerHTML = '';
        COUNTRIES.forEach((country) => {
          const item = document.createElement('li');
          item.setAttribute('role', 'option');
  
          const optionBtn = document.createElement('button');
          optionBtn.type = 'button';
          optionBtn.className = 'trade-app__phone-country-option';
          optionBtn.setAttribute('aria-selected', country.iso === selected.iso ? 'true' : 'false');
          optionBtn.innerHTML = `
            <span class="trade-app__phone-country-option-flag hidden" aria-hidden="true">${country.flag}</span>
            <span class="trade-app__phone-country-option-name">${country.name}</span>
            <span class="trade-app__phone-country-option-dial">${country.dial}</span>
          `;
          optionBtn.addEventListener('click', () => {
            setCountry(country, { focusNational: true });
            closeList();
          });
  
          item.appendChild(optionBtn);
          list.appendChild(item);
        });
      };
  
      btn.addEventListener('click', () => {
        if (list.hidden) openList();
        else closeList();
      });
  
      nationalInput.addEventListener('input', syncFullPhone);
      phoneBox?.addEventListener('click', (event) => {
        if (event.target === nationalInput) return;
        nationalInput.focus();
      });
  
      document.addEventListener('click', (event) => {
        if (!field.contains(event.target)) closeList();
      });
  
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeList();
      });
  
      setCountry(selected);
    }
  
    function setupFileField(field) {
      const input = field.querySelector('[data-trade-file-input]');
      const list = field.querySelector('[data-trade-file-list]');
      const trigger = field.querySelector('[data-trade-file-trigger]');
      if (!input || !list) return;
  
      let files = [];
      let syncingInput = false;
  
      const syncInput = () => {
        syncingInput = true;
        input.value = '';
        const transfer = new DataTransfer();
        files.forEach((file) => transfer.items.add(file));
        input.files = transfer.files;
        syncingInput = false;
        renderList();
      };
  
      const renderList = () => {
        list.innerHTML = '';
        if (!files.length) {
          list.hidden = true;
          return;
        }
  
        list.hidden = false;
        files.forEach((file, index) => {
          const item = document.createElement('li');
          item.className = 'trade-app__file-item';
  
          const name = document.createElement('span');
          name.textContent = file.name;
  
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'trade-app__file-remove';
          remove.textContent = 'Remove';
          remove.addEventListener('click', () => {
            files = files.filter((_, i) => i !== index);
            syncInput();
          });
  
          item.append(name, remove);
          list.appendChild(item);
        });
      };
  
      if (trigger) {
        trigger.addEventListener('click', () => input.click());
      }
  
      input.addEventListener('change', () => {
        if (syncingInput) return;
        const next = Array.from(input.files || []);
        const merged = [...files];
        let rejectionMessage = '';
  
        next.forEach((file) => {
          const ext = '.' + (file.name.split('.').pop() || '').toLowerCase();
          if (!ALLOWED_FILE_EXT.includes(ext)) {
            rejectionMessage = ALLOWED_FILE_MESSAGE;
            return;
          }
          if (file.size > MAX_FILE_BYTES) {
            rejectionMessage = `"${file.name}" is too large. ${MAX_FILE_SIZE_MESSAGE}`;
            return;
          }
          const exists = merged.some(
            (existing) =>
              existing.name === file.name &&
              existing.size === file.size &&
              existing.lastModified === file.lastModified
          );
          if (!exists) merged.push(file);
        });
  
        files = merged;
        syncInput();

        if (rejectionMessage) {
          setFieldError(field, rejectionMessage);
          field.classList.add('is-invalid');
          field.querySelector('[data-trade-field-error]')?.scrollIntoView?.({
            behavior: 'smooth',
            block: 'nearest',
          });
        } else if (files.length) {
          field.classList.remove('is-invalid');
          setFieldError(field, '');
        }
      });
    }
  
    function getFieldContainer(el) {
      if (!el) return null;
      return (
        el.closest('[data-trade-phone-field]') ||
        el.closest('[data-trade-file-field]') ||
        el.closest('fieldset.trade-app__fieldset') ||
        el.closest('.trade-app__field')
      );
    }
  
    function setFieldError(elOrContainer, message) {
      const container =
        elOrContainer?.matches?.('[data-trade-field-error]')
          ? elOrContainer.parentElement
          : getFieldContainer(elOrContainer) || elOrContainer;
      if (!container) return;
  
      const errorEl = container.querySelector('[data-trade-field-error]');
      if (errorEl) {
        errorEl.textContent = message || '';
        errorEl.hidden = !message;
      }
    }
  
    function clearFieldErrorMessage(el) {
      const container = getFieldContainer(el);
      if (!container) return;
      const errorEl = container.querySelector('[data-trade-field-error]');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    }
  
    function clearFieldInvalid(el) {
      if (!el) return;
      el.classList.remove('is-invalid');
  
      const phoneField = el.closest('[data-trade-phone-field]');
      if (phoneField) {
        phoneField.querySelector('.trade-app__phone-box')?.classList.remove('is-invalid');
        phoneField.querySelector('.trade-app__phone-country-btn')?.classList.remove('is-invalid');
      }
  
      const fieldset = el.closest('fieldset');
      if (fieldset) fieldset.classList.remove('is-invalid');
  
      el.closest('[data-trade-file-field]')?.classList.remove('is-invalid');
      clearFieldErrorMessage(el);
    }
  
    function markFieldInvalid(el) {
      if (!el) return;
      el.classList.add('is-invalid');
  
      const phoneField = el.closest('[data-trade-phone-field]');
      if (phoneField) {
        phoneField.querySelector('.trade-app__phone-box')?.classList.add('is-invalid');
        phoneField.querySelector('.trade-app__phone-country-btn')?.classList.add('is-invalid');
      }
    }
  
    function isEmailInput(el) {
      return el instanceof HTMLInputElement && (el.type === 'email' || el.name === 'email');
    }
  
    function isPhoneInput(el) {
      return (
        Boolean(el.closest?.('[data-trade-phone-field]')) ||
        el.name === 'phone' ||
        el.dataset?.fieldType === 'phone'
      );
    }
  
    function isTextLikeInput(el) {
      if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement)) return false;
      if (el instanceof HTMLTextAreaElement) return true;
      const type = (el.type || 'text').toLowerCase();
      return ['text', 'email', 'search', 'url', 'tel'].includes(type);
    }
  
    function requiredMessageFor(el) {
      const key = el?.dataset?.fieldKey || el?.name || '';
      if (key === 'first_name' || key === 'firstName') return 'First name is required';
      if (key === 'last_name' || key === 'lastName') return 'Last name is required';
      if (isEmailInput(el) || key === 'email') return 'Email is required';
      if (isPhoneInput(el) || key === 'phone' || key === 'phone_national') return 'Phone number is required';
      return 'Field is required';
    }
  
    function hasDisallowedSpaces(el) {
      if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement)) return false;
      if (el.type === 'file' || el.type === 'hidden' || el.type === 'checkbox' || el.type === 'radio') {
        return false;
      }
      if (!isTextLikeInput(el) && !isEmailInput(el) && !isPhoneInput(el)) return false;
  
      const value = el.value || '';
      if (!value) return false;
  
      if (isEmailInput(el)) return /\s/.test(value);
      return /^\s/.test(value);
    }
  
    /** Live: red border for leading spaces (or any space in email). */
    function syncLiveFieldValidity(el) {
      if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement)) return;
      if (el.type === 'file' || el.type === 'hidden' || el.type === 'checkbox' || el.type === 'radio') {
        return;
      }
      if (!isTextLikeInput(el) && !isEmailInput(el) && !isPhoneInput(el)) return;
  
      if (hasDisallowedSpaces(el)) {
        markFieldInvalid(el);
        setFieldError(
          el,
          isEmailInput(el)
            ? 'Email cannot contain spaces'
            : 'Please remove the space at the start of this field'
        );
      } else {
        clearFieldInvalid(el);
      }
    }
  
    function setupClearInvalidOnEdit(form) {
      form.addEventListener('input', (event) => {
        const el = event.target;
        if (!(el instanceof HTMLElement)) return;
        syncLiveFieldValidity(el);
      });
  
      form.addEventListener('change', (event) => {
        const el = event.target;
        if (!(el instanceof HTMLElement)) return;
        if (el.matches('input[type="file"]')) return;
        if (el.matches('input[type="checkbox"], input[type="radio"], select')) {
          clearFieldInvalid(el);
          const fieldset = el.closest('fieldset');
          if (fieldset) {
            fieldset.classList.remove('is-invalid');
            clearFieldErrorMessage(fieldset);
          }
        } else {
          syncLiveFieldValidity(el);
        }
      });
    }
  
    function markInvalid(el, firstInvalidRef, message) {
      markFieldInvalid(el);
      setFieldError(el, message || requiredMessageFor(el));
      if (!firstInvalidRef.current) firstInvalidRef.current = el;
    }
  
    function validateForm(form) {
      let valid = true;
      let firstInvalid = { current: null };
  
      form.querySelectorAll('input, select, textarea').forEach((el) => {
        if (el.disabled) return;
        if (el.type === 'file' || el.type === 'hidden') return;
        if (el.type === 'checkbox' || el.type === 'radio') return;
  
        const isEmail = isEmailInput(el);
        const isPhone = isPhoneInput(el);
        const raw = typeof el.value === 'string' ? el.value : '';
        const trimmed = raw.trim();
        const required = el.required || el.getAttribute('aria-required') === 'true';
  
        if (isEmail) {
          if (!raw) {
            if (required) {
              valid = false;
              markInvalid(el, firstInvalid, 'Email is required');
            }
            return;
          }
          if (/\s/.test(raw) || !EMAIL_RE.test(raw)) {
            valid = false;
            markInvalid(el, firstInvalid, 'Please enter a valid email address');
          }
          return;
        }
  
        if (isPhone) {
          if (/^\s/.test(raw)) {
            valid = false;
            markInvalid(el, firstInvalid, 'Please remove the space at the start of this field');
            return;
          }
          if (required && !trimmed) {
            valid = false;
            markInvalid(el, firstInvalid, 'Phone number is required');
          }
          return;
        }
  
        if (isTextLikeInput(el) || el.tagName === 'SELECT' || el.type === 'date' || el.type === 'number') {
          if (!required && !trimmed) return;
  
          if (/^\s/.test(raw)) {
            valid = false;
            markInvalid(el, firstInvalid, 'Please remove the space at the start of this field');
            return;
          }
  
          if (required && !trimmed) {
            valid = false;
            markInvalid(el, firstInvalid, requiredMessageFor(el));
            return;
          }
  
          if (/\s+$/.test(raw)) el.value = raw.replace(/\s+$/g, '');
          return;
        }
  
        if (required && !el.checkValidity()) {
          valid = false;
          markInvalid(el, firstInvalid, requiredMessageFor(el));
        }
      });
  
      form.querySelectorAll('fieldset[data-field-type="checkbox"][data-required="true"]').forEach((fieldset) => {
        const checked = fieldset.querySelectorAll('input[type="checkbox"]:checked').length > 0;
        if (!checked) {
          valid = false;
          fieldset.classList.add('is-invalid');
          setFieldError(fieldset, 'Field is required');
          if (!firstInvalid.current) firstInvalid.current = fieldset.querySelector('input');
        }
      });
  
      form.querySelectorAll('fieldset[data-field-type="radio"][data-required="true"]').forEach((fieldset) => {
        const checked = fieldset.querySelectorAll('input[type="radio"]:checked').length > 0;
        if (!checked) {
          valid = false;
          fieldset.classList.add('is-invalid');
          setFieldError(fieldset, 'Field is required');
          if (!firstInvalid.current) firstInvalid.current = fieldset.querySelector('input');
        }
      });
  
      form.querySelectorAll('input[data-field-type="file"]').forEach((input) => {
        const container = input.closest('[data-trade-file-field]');
        if (!input.required && (!input.files || input.files.length === 0)) return;
  
        if (!input.files || input.files.length === 0) {
          valid = false;
          container?.classList.add('is-invalid');
          setFieldError(container || input, 'Field is required');
          if (!firstInvalid.current) firstInvalid.current = input;
          return;
        }
  
        for (const file of input.files) {
          const ext = '.' + (file.name.split('.').pop() || '').toLowerCase();
          if (!ALLOWED_FILE_EXT.includes(ext)) {
            valid = false;
            container?.classList.add('is-invalid');
            setFieldError(container || input, ALLOWED_FILE_MESSAGE);
            if (!firstInvalid.current) firstInvalid.current = input;
            break;
          }
          if (file.size > MAX_FILE_BYTES) {
            valid = false;
            container?.classList.add('is-invalid');
            setFieldError(container || input, `"${file.name}" is too large. ${MAX_FILE_SIZE_MESSAGE}`);
            if (!firstInvalid.current) firstInvalid.current = input;
            break;
          }
        }
      });
  
      if (!valid) {
        firstInvalid.current?.focus?.();
        firstInvalid.current?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
      }
  
      return valid;
    }
  
    function applyServerFieldErrors(form, errors) {
      Object.entries(errors || {}).forEach(([key, message]) => {
        const mapKey =
          key === 'firstName' ? 'first_name' : key === 'lastName' ? 'last_name' : key;
        let el =
          form.querySelector(`[data-field-key="${mapKey}"]`) ||
          form.querySelector(`[name="${mapKey}"]`);
        if (mapKey === 'phone') {
          el = form.querySelector('[data-trade-phone-national]') || el;
        }
        if (!el) return;
        markFieldInvalid(el);
        if (el.type === 'file') {
          el.closest('[data-trade-file-field]')?.classList.add('is-invalid');
        }
        setFieldError(el, message);
      });
    }
  
    function clearInvalid(form) {
      form.querySelectorAll('.is-invalid').forEach((el) => el.classList.remove('is-invalid'));
      form.querySelectorAll('[data-trade-field-error]').forEach((el) => {
        el.textContent = '';
        el.hidden = true;
      });
    }
  
    function buildPayload(form) {
      const fields = {};
      const files = {};
  
      form.querySelectorAll('[data-field-key]').forEach((el) => {
        const key = el.dataset.fieldKey;
        if (!key) return;
  
        if (el.type === 'file') {
          files[key] = Array.from(el.files || []);
          return;
        }
  
        if (el.type === 'checkbox') {
          if (!el.checked) return;
          if (!Array.isArray(fields[key])) fields[key] = [];
          fields[key].push(el.value);
          return;
        }
  
        if (el.type === 'radio') {
          if (el.checked) fields[key] = el.value;
          return;
        }
  
        fields[key] = el.value;
      });
  
      const phoneField = form.querySelector('[data-trade-phone-field]');
  
      return {
        email: form.querySelector('[name="email"]')?.value || '',
        phone: form.querySelector('[data-trade-phone-full]')?.value || form.querySelector('[name="phone"]')?.value || '',
        phoneCountry: phoneField?.querySelector('[data-trade-phone-iso]')?.value || '',
        phoneDialCode: phoneField?.querySelector('[data-trade-phone-dial-value]')?.value || '',
        firstName: fields.first_name || '',
        lastName: fields.last_name || '',
        tags: (form.dataset.customerTags || '')
          .split(',')
          .map((tag) => tag.trim())
          .filter(Boolean),
        sendCustomerEmail: form.dataset.sendCustomerEmail === 'true',
        adminEmail: form.dataset.adminEmail || '',
        fields,
        files,
      };
    }
  
    function showSuccess(form, successEl, title, message) {
      form.hidden = true;
      if (successEl) {
        const titleEl = successEl.querySelector('[data-trade-success-title]');
        const messageEl = successEl.querySelector('[data-trade-success-message]');
        if (titleEl && title) titleEl.textContent = title;
        if (messageEl && message) messageEl.innerHTML = message;
  
        successEl.hidden = false;
        successEl.focus();
      }
  
      setTimeout(() => {
        window.location.reload();
      }, 10000);
    }
  
    function getEndpointError(endpoint) {
      if (!endpoint) {
        console.error('[trade-application] submission endpoint is not configured');
        return 'We could not submit your application. Please try again later.';
      }
  
      try {
        const url = new URL(endpoint, window.location.origin);
        const isLocalApi = url.hostname === '127.0.0.1' || url.hostname === 'localhost';
        const isLocalPage =
          window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
  
        if (isLocalApi && !isLocalPage) {
          console.error('[trade-application] local API endpoint on a remote page', endpoint);
          return 'We could not submit your application. Please try again later.';
        }
  
        if (window.location.protocol === 'https:' && url.protocol === 'http:' && !isLocalApi) {
          console.error('[trade-application] mixed-content API endpoint', endpoint);
          return 'We could not submit your application. Please try again later.';
        }
      } catch (_) {
        console.error('[trade-application] invalid API endpoint', endpoint);
        return 'We could not submit your application. Please try again later.';
      }
  
      return null;
    }
  
    function showError(errorEl, message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  
    function clearError(errorEl) {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  
    function initAll(root = document) {
      root.querySelectorAll(`[data-section-type="${SECTION_TYPE}"]`).forEach(initSection);
    }
  
    document.addEventListener('DOMContentLoaded', () => initAll());
  
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target) initAll(event.target);
    });
  })();
  